import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
//import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';
import "assets/index.css";

import config from './config';
import {
  AuthContextProvider,
  CartContextProvider,
  ProductsContextProvider,
  WishlistContextProvider,
} from "./front/contexts";
//import i18next from "i18next";
//import { I18nextProvider } from "react-i18next";
//import i18n from "@/i18n";

// ==============================|| REACT DOM RENDER  ||============================== //
/*import global_en from "./components/translation/en/global_en.json";
import global_hi from "./components/translation/hi/global_hi.json";
i18next.init({
  interpolation: {escapeValue:false},
  lan:"en",
  resources: {
    en:{
      global:global_en
    },
    hi:{
      global:global_hi
    },
  },
})*/
const myStyle = {
  backgroundImage:
      "url('./assets/bg-main-top.jpg')",
  height: "100vh",
  marginTop: "-70px",
  fontSize: "50px",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
};
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
let checkurl = window.location.pathname
checkurl = checkurl.match('/admin');
if(!checkurl) config.basename = ''

//console.log = () => {};

root.render(
  <Provider store={store} >
    <AuthContextProvider>
      <ProductsContextProvider>
        <CartContextProvider>
          <WishlistContextProvider>
            <BrowserRouter basename={config.basename}>
              <App />
            </BrowserRouter>
            </WishlistContextProvider>
        </CartContextProvider>
      </ProductsContextProvider>
    </AuthContextProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
